module.exports = __webpack_public_path__ + "ec573217144fbe6fe0e7f9f8265be162.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/main/img/ch.svg
// module id = 54
// module chunks = 0